import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FiRefreshCcw } from "react-icons/fi";
import { FormGroup, FormControl } from "react-bootstrap";
import Loading from "components/Loading";
import Layout from "components/Layout";
import moment from "moment";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import PreferenceEdit from "components/Preferences/PreferenceEditModal";
import { showModal, hideModal } from "actions/modalActions";
import * as shiftsActions from "actions/shiftsActions";
import * as employeesActions from "actions/employeesActions";
import Modal from "components/Modal";
import PendingPreferencesList from "../components/Preferences/PendingPreferencesList";
import PlanNavigationTabs from "../components/Plans/PlanNavigationTabs";
import InfiniteScroll from "react-infinite-scroll-component";
import { workflowsService } from "services";

class PendingPreferences extends Component {
	constructor(props) {
		super(props);

		this.state = {
			focusedInput: null,
			employee_id: -1,
			isSubmit: false,
			is_list_view: true,
			isLoading: false,
			page: 0,
			page_size: 20,
			pending_requests: [],
			hasMore: true,
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.openNewPreferenceModal = this.openNewPreferenceModal.bind(this);
		this.openEditPreferenceModal = this.openEditPreferenceModal.bind(this);
		this.getPendingPreferences = this.getPendingPreferences.bind(this);
	}

	componentDidMount() {
		this.getPendingPreferences();
		this.props.getSelectableEmployees();
		this.props.getAttendanceShifts();
	}

	handleChangeSearch = (event) => {
		const target_id = event.target.id;

		this.setState(
			{
				[target_id]: event.target.value,
				page: 0,
				pending_requests: [],
				hasMore: true,
			},
			async () => {
				await this.getPendingPreferences();
			}
		);
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		this.setState(
			{
				page: 0, // reset pagination
				start_from: startDate,
				start_to: endDate,
				pending_requests: [],
				hasMore: true,
			},
			async () => {
				await this.getPendingPreferences();
			}
		);
	};

	async getPendingPreferences() {
		this.setState({
			isLoading: this.state.page === 0,
		});
		const {
			start_from,
			start_to,
			employee_id,
			page,
			page_size,
			pending_requests,
		} = this.state;

		try {
			const response = await workflowsService.getPendingPreferences({
				start_from,
				start_to,
				employee_id,
				page,
				page_size,
			});

			let new_preferences = [];
			let total_items = 0;

			if (response.data) {
				new_preferences = response.data;
				if (response.pagination && response.pagination.total_items) {
					total_items = response.pagination.total_items;
				} else if (response.total) {
					total_items = response.total;
				}
			} else if (Array.isArray(response)) {
				new_preferences = response;
			}

			let all_preferences = pending_requests;
			if (page === 0) {
				all_preferences = new_preferences;
			} else {
				all_preferences = pending_requests.concat(new_preferences);
			}

			let hasMore = false;
			if (new_preferences.length > 0) {
				if (total_items > 0) {
					hasMore = all_preferences.length < total_items;
				} else {
					hasMore = new_preferences.length === page_size;
				}
			}

			this.setState({
				pending_requests: all_preferences,
				isLoading: false,
				hasMore: hasMore,
			});
		} catch (error) {
			console.error("Error fetching pending preferences:", error);
			this.setState({
				isLoading: false,
				hasMore: false,
			});
		}
	}

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getPendingPreferences();
			}
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewPreferenceModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.newPreference"),
				style: { width: "500px" },
				content: <PreferenceEdit handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditPreferenceModal(preference, disabled) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: disabled
					? t("preferences.viewPreferenceShift")
					: t("preferences.editPreferenceShift"),
				style: { width: "500px" },
				content: (
					<PreferenceEdit
						preference={preference}
						disabled={disabled}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || "Error",
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	reloadPreferences = () => {
		this.setState({ page: 0, pending_requests: [], hasMore: true }, () => {
			this.getPendingPreferences();
		});
	};

	getContent = () => {
		if (this.state.isLoading && this.state.page === 0) {
			return <Loading />;
		}

		const { hasMore, pending_requests } = this.state;

		return (
			<>
				<InfiniteScroll
					dataLength={pending_requests.length}
					next={this.fetchMoreData}
					hasMore={hasMore}
					loader={
						<div style={{ textAlign: "center", padding: "10px" }}>
							Loading...
						</div>
					}
					endMessage={
						pending_requests.length > 0 && (
							<p
								className="no-more-results"
								style={{ textAlign: "center", padding: "10px" }}
							>
								{this.props.t("preferences.noMoreRequests")}
							</p>
						)
					}
				>
					<PendingPreferencesList
						pending_preferences={pending_requests}
						openEditPreferenceModal={this.openEditPreferenceModal}
						openAlertModal={this.openAlertModal}
						reloadPreferences={this.reloadPreferences}
					/>
				</InfiniteScroll>
			</>
		);
	};

	render() {
		const { select_employees = [] } = this.props;

		const employee_in_list = select_employees.some(
			(e) => e.id === this.props.user.id
		);
		if (!employee_in_list) select_employees.push(this.props.user);

		let employeeList =
			select_employees.length > 0 &&
			select_employees.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name} {item.surname}
					</option>
				);
			}, this);
		return (
			<>
				<Layout
					configSidebar={false}
					className="page-absences page-preferences"
					context="plan"
				>
					<div className="heading">
						<h1 className="title">{this.props.t("preferences.pendingTitle")}</h1>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-select-user mr10"
								controlId="employee_id"
							>
								<FormControl
									type="text"
									placeholder={this.props.t("common.search")}
									value={this.state.employee_id}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="-1">{this.props.t("common.searchEmployee")}</option>
									{employeeList}
								</FormControl>
							</FormGroup>

							<DateRangePicker
								startDateId="startDateId"
								endDateId="endDateId"
								startDate={
									this.state.start_from ? moment(this.state.start_from) : null
								}
								endDate={
									this.state.start_to ? moment(this.state.start_to) : null
								}
								startDatePlaceholderText={this.props.t("common.periodStart")}
								endDatePlaceholderText={this.props.t("common.periodEnd")}
								onDatesChange={this.onDatesChange}
								focusedInput={this.state.focusedInput}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
								onFocusChange={(focusedInput) =>
									this.setState({ focusedInput })
								}
							/>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								className="btn btn-primary mr10"
								onClick={this.openNewPreferenceModal}
							>
								<FiRefreshCcw className="mr5" />
								{this.props.t("preferences.requestShift")}
							</button>
						</div>
					</div>

					<PlanNavigationTabs />

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		...reducers.plansReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PendingPreferences));
